import { useMemo } from 'react'
import { IEcommerceAnswerSchema, IEcommerceQuestionSchema } from '../types'

interface IUseChildrenProductsProps {
  answer: IEcommerceAnswerSchema
  schema: IEcommerceQuestionSchema
  excludeCurrentProduct?: boolean
}

export const useChildrenProducts = ({ answer, schema, excludeCurrentProduct = false }: IUseChildrenProductsProps) =>
  useMemo(() => {
    const answersMap = new Map(schema.answers.map(product => [product.market_place_id, product]))
    if (!answer.parent_product) {
      const children = schema.answers.filter(
        product => product.parent_product && product.parent_product === answer.market_place_id
      )
      return [...(excludeCurrentProduct ? [] : [answer]), ...children]
    }
    const parentProduct = answersMap.get(answer.parent_product)
    if (!parentProduct) return []
    const children = schema.answers.filter(
      product => product.parent_product && product.parent_product === parentProduct.market_place_id
    )
    const result = [parentProduct, ...children]

    return excludeCurrentProduct ? result.filter(product => product.id !== answer.id) : result
  }, [answer, schema, excludeCurrentProduct])
